import React from "react";

const zoomOptions = [50, 70, 80, 85, 90, 95, 100, 105, 110, 120, 150];

// US letter in absolute dimensions. The `size: letter landscape` keyword form is
// legal CSS, but print-to-PDF on Windows was still handing back a portrait
// 612x792 page with the table rotated sideways onto it. The booklet view has
// always printed landscape in the wild and states its page this way, so this
// does too — an explicit size leaves the driver nothing to reinterpret.
const PAGE_SIZE = {
    landscape: '11in 8.5in',
    portrait: '8.5in 11in',
};

const PrintControls = ({ defaultOrientation = 'landscape', defaultZoom = 100, printSelector = '.print-container' }) => {
    const [zoom, setZoom] = React.useState(defaultZoom);

    React.useEffect(() => {
        // !important + first-in-head AND last-in-head, the shape PrintBooklet.js
        // arrived at: several print views inject their own
        // `@page { size: ... !important }` while they are mounted, and among
        // competing !important @page sizes Chromium honours the FIRST in
        // document order while spec-correct engines honour the last. The rule
        // therefore goes in at both ends of the head.
        //
        // The @page rule sits outside @media print, as a bare rule — it only
        // applies to paged media anyway, and this is the form that is known to
        // survive the trip through a print driver.
        const size = PAGE_SIZE[defaultOrientation] || PAGE_SIZE.landscape;
        const pageCss = `@page { size: ${size} !important; margin: 0 !important; }`;
        const first = document.createElement('style');
        first.setAttribute('data-print-controls', 'true');
        first.innerHTML = pageCss;
        const last = document.createElement('style');
        last.setAttribute('data-print-controls', 'true');
        last.innerHTML = pageCss;

        // The zoom and the hidden controls are ordinary print styles.
        const rules = document.createElement('style');
        rules.setAttribute('data-print-controls', 'true');
        rules.innerHTML = `
        @media print {
            .PrintControls {
                display: none !important;
            }
            ${printSelector} {
                zoom: ${zoom / 100};
            }
        }`;

        document.head.insertBefore(first, document.head.firstChild);
        document.head.appendChild(rules);
        document.head.appendChild(last);
        return () => {
            document.head.removeChild(first);
            document.head.removeChild(rules);
            document.head.removeChild(last);
        };
    }, [zoom, defaultOrientation, printSelector]);

    return (
        <div className="PrintControls" style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 0' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '11px' }}>
                Zoom:
                <select
                    value={zoom}
                    onChange={(e) => setZoom(Number(e.target.value))}
                    style={{ fontSize: '11px' }}
                >
                    {zoomOptions.map(val => (
                        <option key={val} value={val}>{val}%</option>
                    ))}
                </select>
            </label>
            <button
                type="button"
                onClick={() => window.print()}
                style={{ padding: '4px 10px', borderRadius: '4px', border: '1px solid #ccc', background: '#666', color: '#fff', cursor: 'pointer', fontSize: '11px', fontWeight: 500, lineHeight: 1, margin: 0 }}
            >
                Print
            </button>
        </div>
    );
};

export default PrintControls;
